import { useMemo } from "react"
import { useQuery } from "@tanstack/react-query"
import { API, Moment } from "config"

const useOrdersMonthlyData = () => {
    // Stable — computed once at mount, month boundaries don't change during a session
    const months = useMemo(() => Array.from({ length: 12 }, (_, i) => {
        const start = Moment().subtract(11 - i, "months").startOf("month")
        const end   = start.clone().endOf("month")
        return {
            startUnix: start.unix(),
            endUnix:   end.unix(),
            date:      start.format("YYYY-MM-DD"),
            label:     start.format("MMM/YY"),
        }
    }), [])

    const query = useQuery({
        queryKey: ["orders-monthly-chart"],
        queryFn: async () => {
            // Parallel — all 12 months at once; individual failures fall back to 0
            const settled = await Promise.allSettled(
                months.map(async ({ startUnix, endUnix }) => {
                    const { data } = await API.get(
                        `/orders/list?page=1&distributor=all&order_by=created_at&start=${startUnix}&end=${endUnix}`
                    )
                    return data?.meta?.total ?? 0
                })
            )
            return settled.map(r => r.status === "fulfilled" ? r.value : 0)
        },
        staleTime:           1000 * 60 * 60,
        gcTime:              1000 * 60 * 60 * 24,
        refetchOnWindowFocus: false,
        retry: 1,
    })

    return {
        isLoading: query.isLoading,
        dates:  months.map(m => m.date),
        labels: months.map(m => m.label),
        values: query.data ?? Array(12).fill(0),
    }
}

export default useOrdersMonthlyData
